var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17,
    viewBox: "0 0 20.948 16.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-mail",
    "data-name": "Icon ionic-md-mail",
    d: "M21.2,5.625H4.245a2,2,0,0,0-2,2V20.089a2,2,0,0,0,2,2H21.2a2,2,0,0,0,2-2V7.62A2,2,0,0,0,21.2,5.625Zm-.249,4.24-8.23,5.486L4.494,9.865v-2l8.23,5.486,8.23-5.486Z",
    transform: "translate(-2.25 -5.625)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.26132961f7d48fd3459bcc6f965b4292.svg";
export { ForwardRef as ReactComponent };